import { render, staticRenderFns } from "./OnboardingInProgress.vue?vue&type=template&id=513155b2&"
import script from "./OnboardingInProgress.vue?vue&type=script&lang=js&"
export * from "./OnboardingInProgress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports